"use client";

import * as React from "react";

// Next.js App Router segment error boundary — catches client render errors in
// the page subtree (a layout-level error bubbles to global-error.tsx instead).
// Its useEffect reports the caught error to the server so it appears in our
// logs; with production source maps, error.stack de-minifies to the culprit.
function reportToServer(kind: string, error: Error & { digest?: string }) {
  try {
    const body = JSON.stringify({
      kind,
      message: error.message,
      stack: error.stack,
      digest: error.digest,
      url: typeof window !== "undefined" ? window.location.href : null,
      reportedAt: new Date().toISOString(),
    });

    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      navigator.sendBeacon("/api/client-error", new Blob([body], { type: "application/json" }));
      return;
    }

    void fetch("/api/client-error", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body,
      keepalive: true,
    });
  } catch {
    // Never let error reporting throw.
  }
}

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  React.useEffect(() => {
    reportToServer("segment-error", error);
  }, [error]);

  return (
    <div style={{ padding: 24, fontFamily: "system-ui, -apple-system, sans-serif" }}>
      <h2 style={{ fontSize: 18, marginBottom: 8 }}>Something went wrong</h2>
      <p style={{ color: "#64748b", marginBottom: 16 }}>This section hit an unexpected error.</p>
      <button
        type="button"
        onClick={() => reset()}
        style={{
          borderRadius: 10,
          border: "1px solid #cbd5e1",
          background: "#fff",
          padding: "8px 16px",
          cursor: "pointer",
        }}
      >
        Try again
      </button>
    </div>
  );
}
